"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hasDeviceOrientationSupport = function hasDeviceOrientationSupport() {
  return typeof window !== 'undefined' && 'DeviceOrientationEvent' in window;
};

var hasScreenOrientationSupport = function hasScreenOrientationSupport() {
  return typeof screen !== 'undefined' && typeof screen.orientation !== 'undefined';
};
/**
 * Adds a device orientation change listener to detect if the user rotate back to portrait.
 * If the user does so, screen.orientation is unlocked.
 *
 * Implementation based on:
 * https://developers.google.com/web/fundamentals/media/mobile-web-video-playback#unlock_screen_on_device_orientation_change
 */


exports.unlockOnPortrait = function () {
  if (!hasDeviceOrientationSupport() || !hasScreenOrientationSupport()) {
    return;
  }

  var previousDeviceOrientation;
  var currentDeviceOrientation;

  var onDeviceOrientationChange = function onDeviceOrientationChange(ev) {
    // ev.beta represents a front to back motion of the device and
    // ev.gamma a left to right motion.
    var gamma = ev.gamma || 0;
    var beta = ev.beta || 0;

    if (Math.abs(gamma) > 10 || Math.abs(beta) < 10) {
      previousDeviceOrientation = currentDeviceOrientation;
      currentDeviceOrientation = 'landscape';
      return;
    }

    if (Math.abs(gamma) < 10 || Math.abs(beta) > 10) {
      previousDeviceOrientation = currentDeviceOrientation; // When device is rotated back to portrait, let's unlock screen orientation.

      if (previousDeviceOrientation === 'landscape') {
        screen.orientation.unlock();
        window.removeEventListener('deviceorientation', onDeviceOrientationChange);
      }
    }
  };

  window.addEventListener('deviceorientation', onDeviceOrientationChange); // Return unlisten function

  return function () {
    window.removeEventListener('deviceorientation', onDeviceOrientationChange);
  };
};

exports.default = exports.unlockOnPortrait;